export const ASSETS_URL = 'https://portfolio-ks.s3.ap-south-1.amazonaws.com/'
// export const BASE_URL = 'https://motionless-bell-bottoms-calf.cyclic.app'
export const BASE_URL = 'https://srinivas-backend-portfolio.onrender.com'
